import { userConstants,CouponConstants, CategoryConstants } from "../_constants";
import * as commonAction from "./commonAction";
import { userService, commonService } from "../_services";
import { alertActions } from "./";
import { history } from "../_helpers";
import { taxSettingsConstants } from "../_constants/taxSettings.constant";

//import rootReducer from '../_reducers';
//import { createStore } from 'redux'

//const store = createStore(rootReducer)

export const TaxActions = {
    saveTaxSettings,
    getTaxSettings,
    editTaxSettings,
    deleteTaxSettings,

};

//-- save tax country
function saveTaxSettings(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(taxSettingsConstants.TAX_ADD_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(taxSettingsConstants.TAX_ADD_SETTINGS_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(taxSettingsConstants.TAX_ADD_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

// get all tax settings
function getTaxSettings(apiName, catObj) {
    return dispatch => {
      dispatch(commonAction.request(taxSettingsConstants.GET_ALL_TAX_SETTINGS_REQUEST, catObj ));
      commonService.withTokenPut(apiName, catObj).then(
        categoryData => {        
                          dispatch(commonAction.success(taxSettingsConstants.GET_ALL_TAX_SETTINGS_SUCCESS, categoryData));
                        },
        error => {
                    dispatch( commonAction.failure(taxSettingsConstants.GET_ALL_TAX_SETTINGS_FAILURE, error) );                  
                 }
        );
    };
  }


  
//-- edit tax country
function editTaxSettings(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(taxSettingsConstants.TAX_EDIT_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(taxSettingsConstants.TAX_EDIT_SETTINGS_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(taxSettingsConstants.TAX_EDIT_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

// delete a tax setting record by id and admin
function deleteTaxSettings(apiName, catObj) {
  return dispatch => {
    dispatch(commonAction.request(taxSettingsConstants.TAX_DELETE_SETTINGS_REQUEST, catObj ));
    commonService.withTokenPut(apiName, catObj).then(
      categoryData => {        
                        dispatch(commonAction.success(taxSettingsConstants.TAX_DELETE_SETTINGS_SUCCESS, categoryData));
                      },
      error => {
                  dispatch( commonAction.failure(taxSettingsConstants.TAX_DELETE_SETTINGS_FAILURE, error) );                  
               }
      );
  };
}

 
 
 